"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = getValidObject;

require("core-js/modules/es6.object.assign");

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function getValidObject(object) {
  if (!object) {
    return {};
  } else if (Array.isArray(object) || (0, _typeof2.default)(object) !== 'object') {
    throw new TypeError("Not an object. Provided value: ".concat(object));
  } else {
    return Object.assign({}, object);
  }
}